import ShopifyStore from 'umg-ember-backend/components/record-explorer/for/shopify-store';

<template>
  <ShopifyStore @records={{@model}} @recordType='shopify-store' />
</template>
